import { all, takeLatest, call, put } from 'redux-saga/effects';
import Axios, { AxiosResponse } from 'axios';
import { userPlanUpgradeSuccess, userPlanUpgradeFailure } from './actions';
import { UpgradeActionTypes } from './types';
import { planUpgrade } from 'services/user.service';

function* handleUserPlanUpgrade(request: any) {
  try {
    const response: AxiosResponse = yield planUpgrade(request.payload);
    if (response) {
      yield put(userPlanUpgradeSuccess(response.data));
    } else {
      yield put(userPlanUpgradeFailure('Unable to request user plan upgrade'));
    }
  } catch (err) {
    const errMsg = Axios.isAxiosError(err)
      ? err.response?.data?.msg
      : undefined;
    yield put(
      userPlanUpgradeFailure(errMsg || 'Unable to request user plan upgrade')
    );
  }
}

function* watchUserPlanUpgrade() {
  yield takeLatest(
    UpgradeActionTypes.USER_PLAN_UPGRADE_START,
    handleUserPlanUpgrade
  );
}

function* sagas() {
  yield all([call(watchUserPlanUpgrade)]);
}

export default sagas;
